import { Injectable } from '@angular/core';
import { CompanyActions, OccCompanyService } from '@company/data-access';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { AuthActions, OCC_USER_ID_ANONYMOUS, UserIdService } from '@spartacus/core';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

@Injectable()
export class UserCompaniesEffects {
  loadUserCompanies$: Observable<CompanyActions.LoadUserCompaniesSuccess | CompanyActions.LoadUserCompaniesFail> =
    createEffect(() =>
      this.actions$.pipe(
        ofType<CompanyActions.LoadUserCompanies>(CompanyActions.LOAD_USER_COMPANIES),
        concatLatestFrom(() => this.userIdService.getUserId()),
        switchMap(([, userId]) => {
          if (userId === OCC_USER_ID_ANONYMOUS) {
            return of(new CompanyActions.LoadUserCompaniesFail());
          }

          return this.occCompanyService.loadUserCompanies(userId).pipe(
            map((res) => new CompanyActions.LoadUserCompaniesSuccess(res)),
            catchError(() => of(new CompanyActions.LoadUserCompaniesFail())),
          );
        }),
      ),
    );

  loadUserCompaniesAfterLogin$: Observable<CompanyActions.LoadUserCompanies> = createEffect(() =>
    this.actions$.pipe(
      ofType<AuthActions.Login>(AuthActions.LOGIN),
      map(() => new CompanyActions.LoadUserCompanies()),
    ),
  );

  loadUserCompaniesAfterInit$: Observable<CompanyActions.LoadUserCompanies> = createEffect(() =>
    this.actions$.pipe(
      ofType<CompanyActions.InitializeCompanyFeature>(CompanyActions.INITIALIZE_COMPANY_FEATURE),
      map(() => new CompanyActions.LoadUserCompanies()),
    ),
  );

  loadUserCompaniesAfterRemoveSuccess$: Observable<CompanyActions.LoadUserCompanies> = createEffect(() =>
    this.actions$.pipe(
      ofType<CompanyActions.RemoveCompanySuccess>(CompanyActions.REMOVE_COMPANY_SUCCESS),
      map(() => new CompanyActions.LoadUserCompanies()),
    ),
  );

  loadUserCompaniesAfterAddSuccess$: Observable<CompanyActions.LoadUserCompanies> = createEffect(() =>
    this.actions$.pipe(
      ofType<CompanyActions.AddCompanySuccess>(CompanyActions.ADD_COMPANY_SUCCESS),
      map(() => new CompanyActions.LoadUserCompanies()),
    ),
  );

  resetUserCompaniesAfterLogout$: Observable<CompanyActions.ResetUserCompanies> = createEffect(() =>
    this.actions$.pipe(
      ofType<AuthActions.Logout>(AuthActions.LOGOUT),
      map(() => new CompanyActions.ResetUserCompanies()),
    ),
  );

  constructor(
    private actions$: Actions,
    private occCompanyService: OccCompanyService,
    private userIdService: UserIdService,
  ) {}
}
